import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "closeIcon" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "tips" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(",当前已超限,请升级vip,尊享高级和更多权益！")
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("现在去升级")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("我要再看看")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanIcon = _resolveComponent("VanIcon")!
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanPopup = _resolveComponent("VanPopup")!

  return (_openBlock(), _createBlock(_component_VanPopup, {
    class: "RestrictDialog",
    show: $props.modelValue,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (($props.modelValue) = $event)),
    onClose: $setup.close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_VanIcon, {
            name: "close",
            size: "20",
            onClick: $setup.close
          })
        ]),
        _createVNode(_component_VanImage, { src: "https://mdd-static.oss-cn-hangzhou.aliyuncs.com/app/vip/to_update_vip_new.png" }),
        _createElementVNode("div", _hoisted_3, _toDisplayString([104,120,107,121,122].includes($props.code)?'号码查看超限制':'苗豆不足'), 1),
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode("您是" + _toDisplayString($setup.vpiLevel) + ",可查看电话 ", 1),
          _createElementVNode("span", null, _toDisplayString($setup.permissionData[$setup.props.type][String(!($setup.vipRank>5))]), 1),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_VanButton, {
            color: "#FEC64B",
            block: "",
            round: "",
            onClick: $setup.jumpApplet
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_VanButton, {
            color: "#FEC64B",
            plain: "",
            block: "",
            round: "",
            onClick: $setup.close
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}